import type { TypeSortKind } from '@/types/list/types.list.filter';

const DIRECTION: Record<TypeSortKind, { asc: string; desc: string }> = {
    text: { asc: 'A → Z', desc: 'Z → A' },
    date: { asc: 'Meno recenti prima', desc: 'Più recenti prima' },
    number: { asc: 'Dal più basso', desc: 'Dal più alto' },
};

export const listSortDirection = (option: { kind?: TypeSortKind; asc?: string; desc?: string }): { asc?: string; desc?: string } => ({
    asc: option.asc ?? (option.kind ? DIRECTION[option.kind].asc : undefined),
    desc: option.desc ?? (option.kind ? DIRECTION[option.kind].desc : undefined),
});

export default listSortDirection;
